










































import { Vue, Component, Prop, PropSync, Ref } from 'vue-property-decorator'
import ModalDialog from 'components/modals/Dialog.vue'

@Component({
  components: {
    ModalDialog
  }
})
export default class ContactButtonGroupFilter extends Vue {
  loading = false
  value: Set<number> = new Set()

  @Prop()
  readonly groups!: Json[]

  @PropSync('selectedSync')
  selected!: number[]

  @Ref()
  readonly dialog!: ModalDialog

  select () {
    this.value = new Set(this.selected)
    this.dialog.show()
  }

  toggle (id: number) {
    if (this.value.has(id)) {
      this.value.delete(id)
    } else {
      this.value.add(id)
    }
    this.value = new Set(this.value)
  }

  action (action: string) {
    this.dialog.hide()
    switch (action) {
      case 'middle':
        this.selected = []
        break;
      case 'right':
        this.selected = [...this.value]
        break;
    }
  }
}
